import React, { useCallback, useEffect, useMemo, useState } from "react";
import NavBar from "../../../Common/NavBar";
import axios from "axios";
import {
  base,
  PausasActivasURL,
  PausasActivasAudioURL,
  PausasActivasEnviosURL,
  PausasActivasSomnolenciaURL,
  PausasProgramadasURL,
  PausasProgramadasDirectasURL,
  DisxEmp,
} from "../../../API/apiurls";
import { Badge, Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";

function getLocalDateInput() {
  const now = new Date();
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
}

const createEmptyProgramacion = () => ({
  nombre: "",
  descripcion: "",
  tipo: "SOMNOLENCIA",
  duracionEstimadaseg: 180,
  audioArchivo: "",
  estado: true,
  alcance: "DISPOSITIVO",
  dispositivoId: "",
  horaEjecucion: "08:00",
  repeticion: "NINGUNA",
  fechaInicio: getLocalDateInput(),
  fechaFin: "",
  activo: true,
  usuarioCreador: "API",
});

const dayOptions = [
  { value: 1, label: "Lun" },
  { value: 2, label: "Mar" },
  { value: 3, label: "Mié" },
  { value: 4, label: "Jue" },
  { value: 5, label: "Vie" },
  { value: 6, label: "Sáb" },
  { value: 7, label: "Dom" },
];

const shellStyles = {
  minHeight: "100vh",
  paddingTop: 92,
  paddingBottom: 28,
  background: "#080404",
};

const heroCardStyles = {
  background: "#111827",
  border: "1px solid #334155",
  borderRadius: 28,
  boxShadow: "0 18px 38px rgba(0, 0, 0, 0.35)",
  color: "#e5e7eb",
};

const sectionCardStyles = {
  background: "#111827",
  border: "1px solid #334155",
  borderRadius: 24,
  boxShadow: "0 18px 38px rgba(0, 0, 0, 0.35)",
  color: "#e5e7eb",
  height: "100%",
};

const listCardStyles = {
  ...sectionCardStyles,
  minHeight: 540,
};

const inputDark = "border-secondary";
const darkFieldStyle = {
  background: "#0f172a",
  color: "#f8fafc",
  border: "1px solid #334155",
};

function StatPill({ label, value, accent = "#38bdf8" }) {
  return (
    <div
      style={{
        borderRadius: 18,
        padding: "14px 16px",
        background: "rgba(15, 23, 42, 0.68)",
        border: "1px solid rgba(148, 163, 184, 0.15)",
        minWidth: 140,
      }}
    >
      <div style={{ fontSize: 12, opacity: 0.7, textTransform: "uppercase", letterSpacing: 0.8 }}>{label}</div>
      <div style={{ fontSize: 24, fontWeight: 800, color: accent, lineHeight: 1.05 }}>{value}</div>
    </div>
  );
}

function EmptyState({ text }) {
  return (
    <div
      style={{
        border: "1px dashed rgba(148, 163, 184, 0.24)",
        borderRadius: 20,
        padding: 28,
        textAlign: "center",
        color: "#cbd5e1",
        background: "rgba(15, 23, 42, 0.45)",
      }}
    >
      {text}
    </div>
  );
}

function SectionHeader({ title, subtitle }) {
  return (
    <div style={{ marginBottom: 16 }}>
      <h3 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "#f8fafc" }}>{title}</h3>
      {subtitle && <div style={{ marginTop: 6, color: "#cbd5e1", fontSize: 14, lineHeight: 1.5 }}>{subtitle}</div>}
    </div>
  );
}

function formatDate(value) {
  if (!value) return "-";
  return String(value).replace("T", " ");
}

function stateVariant(value) {
  const normalized = String(value || "").toUpperCase();
  if (normalized.includes("ENVIADO") || normalized.includes("RECIBIDO") || normalized.includes("REPRODUCIDO")) {
    return "success";
  }
  if (normalized.includes("FALL")) return "danger";
  if (normalized.includes("CANCEL")) return "secondary";
  return "warning";
}

function severityVariant(value) {
  const normalized = String(value || "").toUpperCase();
  if (normalized === "CRITICA") return "danger";
  if (normalized === "ALTA") return "warning";
  if (normalized === "MEDIA") return "info";
  return "success";
}

function parseList(value) {
  if (!value) return [];
  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function describeTargets(programacion, dispositivos) {
  const alcance = String(programacion?.alcance || "").toUpperCase();
  if (alcance === "TODOS") return "Todos los dispositivos activos";
  if (alcance === "SELECCIONADOS") {
    const ids = parseList(programacion?.dispositivosJson);
    const labels = dispositivos
      .filter((dispositivo) => ids.includes(Number(dispositivo.id)))
      .map((dispositivo) => `${dispositivo.id} - ${dispositivo.nombre}`);
    return labels.length ? labels.join(" · ") : `${ids.length} dispositivos seleccionados`;
  }
  if (programacion?.dispositivoId) {
    const match = dispositivos.find((item) => Number(item.id) === Number(programacion.dispositivoId));
    return match ? `${match.id} - ${match.nombre}` : `Dispositivo ${programacion.dispositivoId}`;
  }
  return "Sin destino definido";
}

function formatDiasSemana(value) {
  const values = parseList(value).map((item) => Number(item));
  if (!values.length) return "-";
  return values
    .map((day) => dayOptions.find((option) => option.value === day)?.label || String(day))
    .join(", ");
}

function buildPauseAudioUrl(audioArchivo) {
  if (!audioArchivo) return "";
  return `${base}/files/audios-rs/${encodeURIComponent(audioArchivo)}`;
}

export function PausasActivas() {
  const empresaId = Number(localStorage.getItem("empresaid") || 1);
  const [tab, setTab] = useState("catalogo");
  const [loading, setLoading] = useState(true);
  const [pausas, setPausas] = useState([]);
  const [envios, setEnvios] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [programaciones, setProgramaciones] = useState([]);
  const [dispositivos, setDispositivos] = useState([]);
  const [selectedPauseId, setSelectedPauseId] = useState(null);
  const [programacionForm, setProgramacionForm] = useState(createEmptyProgramacion());
  const [selectedProgramacionDevices, setSelectedProgramacionDevices] = useState([]);
  const [selectedDias, setSelectedDias] = useState([]);
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [selectedProgramacionId, setSelectedProgramacionId] = useState(null);
  const [audioFile, setAudioFile] = useState(null);

  const loadAll = useCallback(async () => {
    try {
      setLoading(true);
      const [p, e, s, pr, d] = await Promise.all([
        axios.get(`${PausasActivasURL}?empresaId=${empresaId}`),
        axios.get(`${PausasActivasEnviosURL}?empresaId=${empresaId}`),
        axios.get(`${PausasActivasSomnolenciaURL}?empresaId=${empresaId}`),
        axios.get(`${PausasProgramadasURL}?empresaId=${empresaId}`),
        axios.get(DisxEmp, {
          params: {
            empresaId,
            estado: true,
            page: 0,
            size: 500,
          },
        }),
      ]);
      setPausas(p.data || []);
      setEnvios(e.data || []);
      setEventos(s.data || []);
      setProgramaciones(Array.isArray(pr.data) ? pr.data : pr.data?.content || []);
      setDispositivos(d.data?.content || d.data || []);
    } catch (error) {
      console.error("Error cargando pausas activas:", error);
      Swal.fire("Error", "No fue posible cargar las pausas activas", "error");
    } finally {
      setLoading(false);
    }
  }, [empresaId]);

  useEffect(() => {
    loadAll();
  }, [loadAll]);

  const metrics = useMemo(
    () => [
      { label: "Pausas activas", value: pausas.length, accent: "#38bdf8" },
      { label: "Envíos", value: envios.length, accent: "#34d399" },
      { label: "Programadas", value: programaciones.length, accent: "#a78bfa" },
    ],
    [pausas.length, envios.length, programaciones.length]
  );

  const handleProgramacionSubmit = async (e) => {
    e.preventDefault();
    try {
      let resolvedAudioArchivo = programacionForm.audioArchivo;
      if (audioFile) {
        const formData = new FormData();
        formData.append("audio", audioFile);
        if (programacionForm.audioArchivo) {
          formData.append("filename", programacionForm.audioArchivo);
        }
        const uploadResponse = await axios.post(PausasActivasAudioURL, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        resolvedAudioArchivo = uploadResponse.data?.filename || programacionForm.audioArchivo || audioFile.name;
        setProgramacionForm((prev) => ({ ...prev, audioArchivo: resolvedAudioArchivo }));
      }

      if (selectedPauseId) {
        const payload = {
          nombre: programacionForm.nombre,
          descripcion: programacionForm.descripcion,
          tipo: programacionForm.tipo,
          duracionEstimadaseg: Number(programacionForm.duracionEstimadaseg),
          audioArchivo: resolvedAudioArchivo,
          estado: programacionForm.estado,
          empresaId,
          usuarioCreador: "API",
        };

        await axios.put(`${PausasActivasURL}/${selectedPauseId}`, payload);
        setSelectedPauseId(null);
        setAudioFile(null);
        setProgramacionForm(createEmptyProgramacion());
        setShowPauseModal(false);
        await loadAll();
        Swal.fire("Guardado", "Pausa activa por defecto actualizada", "success");
        return;
      }

      if (selectedProgramacionId) {
        const alcance = programacionForm.alcance;
        const payload = {
          empresaId,
          nombre: programacionForm.nombre,
          descripcion: programacionForm.descripcion,
          tipo: programacionForm.tipo,
          duracionEstimadaseg: Number(programacionForm.duracionEstimadaseg),
          audioArchivo: resolvedAudioArchivo,
          estado: programacionForm.estado,
          usuarioCreador: "API",
          alcance,
          dispositivoId:
            alcance === "DISPOSITIVO" && programacionForm.dispositivoId ? Number(programacionForm.dispositivoId) : null,
          dispositivosJson:
            alcance === "SELECCIONADOS" ? JSON.stringify(selectedProgramacionDevices.map((id) => Number(id))) : null,
          diasSemanaJson:
            programacionForm.repeticion === "SEMANAL" ? JSON.stringify(selectedDias.map((id) => Number(id))) : null,
          horaEjecucion:
            typeof programacionForm.horaEjecucion === "string"
              ? `${programacionForm.horaEjecucion}:00`
              : programacionForm.horaEjecucion,
          repeticion: programacionForm.repeticion,
          fechaInicio: programacionForm.fechaInicio || null,
          fechaFin: programacionForm.fechaFin || null,
          activo: programacionForm.activo,
        };

        await axios.put(`${PausasProgramadasURL}/${selectedProgramacionId}`, payload);
        setSelectedProgramacionId(null);
        setAudioFile(null);
        setProgramacionForm(createEmptyProgramacion());
        setSelectedProgramacionDevices([]);
        setSelectedDias([]);
        setShowPauseModal(false);
        await loadAll();
        Swal.fire("Guardado", "Pausa programada actualizada", "success");
        return;
      }

      const alcance = programacionForm.alcance;
      const payload = {
        empresaId,
        nombre: programacionForm.nombre,
        descripcion: programacionForm.descripcion,
        tipo: programacionForm.tipo,
        duracionEstimadaseg: Number(programacionForm.duracionEstimadaseg),
        audioArchivo: resolvedAudioArchivo,
        estado: programacionForm.estado,
        usuarioCreador: "API",
        alcance,
        dispositivoId:
          alcance === "DISPOSITIVO" && programacionForm.dispositivoId ? Number(programacionForm.dispositivoId) : null,
        dispositivosJson:
          alcance === "SELECCIONADOS" ? JSON.stringify(selectedProgramacionDevices.map((id) => Number(id))) : null,
        diasSemanaJson:
          programacionForm.repeticion === "SEMANAL" ? JSON.stringify(selectedDias.map((id) => Number(id))) : null,
        horaEjecucion:
          typeof programacionForm.horaEjecucion === "string"
            ? `${programacionForm.horaEjecucion}:00`
            : programacionForm.horaEjecucion,
        repeticion: programacionForm.repeticion,
        fechaInicio: programacionForm.fechaInicio || null,
        fechaFin: programacionForm.fechaFin || null,
        activo: programacionForm.activo,
      };

      await axios.post(PausasProgramadasDirectasURL, payload);
      setAudioFile(null);
      setProgramacionForm(createEmptyProgramacion());
      setSelectedProgramacionDevices([]);
      setSelectedDias([]);
      setShowPauseModal(false);
      await loadAll();
      Swal.fire("Guardado", "Pausa programada creada correctamente", "success");
    } catch (error) {
      console.error("Error guardando programación:", error);
      Swal.fire("Error", "No se pudo guardar la programación", "error");
    }
  };

  const toggleSelectedProgramacionDevice = (deviceId) => {
    setSelectedProgramacionDevices((prev) =>
      prev.includes(deviceId) ? prev.filter((item) => item !== deviceId) : [...prev, deviceId]
    );
  };

  const toggleSelectedDia = (dayValue) => {
    setSelectedDias((prev) => (prev.includes(dayValue) ? prev.filter((item) => item !== dayValue) : [...prev, dayValue]));
  };

  const handleProgramacionScopeChange = (value) => {
    setProgramacionForm((prev) => ({
      ...prev,
      alcance: value,
      dispositivoId: value === "DISPOSITIVO" ? prev.dispositivoId : "",
    }));
    if (value !== "SELECCIONADOS") {
      setSelectedProgramacionDevices([]);
    }
  };

  const handleProgramacionRepeatChange = (value) => {
    setProgramacionForm((prev) => ({ ...prev, repeticion: value }));
    if (value !== "SEMANAL") {
      setSelectedDias([]);
    }
  };

  const openCreatePauseModal = () => {
    setSelectedPauseId(null);
    setSelectedProgramacionId(null);
    setSelectedProgramacionDevices([]);
    setSelectedDias([]);
    setAudioFile(null);
    setProgramacionForm(createEmptyProgramacion());
    setShowPauseModal(true);
  };

  const openQuickPauseModal = () => {
    const defaultPause = pausas[0];
    if (!defaultPause) {
      Swal.fire("Falta pausa", "Primero cree una pausa activa de envío rápido.", "warning");
      return;
    }
    setSelectedPauseId(defaultPause.id);
    setSelectedProgramacionId(null);
    setAudioFile(null);
    setProgramacionForm((prev) => ({
      ...prev,
      nombre: defaultPause.nombre || "",
      descripcion: defaultPause.descripcion || "",
      tipo: defaultPause.tipo || "SOMNOLENCIA",
      duracionEstimadaseg: defaultPause.duracionEstimadaseg ?? 180,
      audioArchivo: defaultPause.audioArchivo || "",
      estado: defaultPause.estado ?? true,
    }));
    setShowPauseModal(true);
  };

  const openProgramacionEditModal = (programacion) => {
    setSelectedPauseId(null);
    setSelectedProgramacionId(programacion.id);
    setAudioFile(null);
    setProgramacionForm((prev) => ({
      ...prev,
      nombre: programacion.nombre || "",
      descripcion: programacion.descripcion || "",
      tipo: programacion.tipo || "SOMNOLENCIA",
      duracionEstimadaseg: programacion.duracionEstimadaseg ?? 180,
      audioArchivo: programacion.audioArchivo || "",
      estado: programacion.estado ?? true,
      alcance: programacion.alcance || "DISPOSITIVO",
      dispositivoId: programacion.dispositivoId || "",
      horaEjecucion: String(programacion.horaEjecucion || "08:00").slice(0, 5),
      repeticion: programacion.repeticion || "NINGUNA",
      fechaInicio: programacion.fechaInicio || getLocalDateInput(),
      fechaFin: programacion.fechaFin || "",
      activo: programacion.activo ?? true,
    }));
    setSelectedProgramacionDevices(parseList(programacion.dispositivosJson).map((id) => Number(id)));
    setSelectedDias(parseList(programacion.diasSemanaJson).map((id) => Number(id)));
    setShowPauseModal(true);
  };

  const handleAudioUploadChange = (file) => {
    setAudioFile(file || null);
    if (file && !programacionForm.audioArchivo) {
      const fallbackName = file.name.toLowerCase().endsWith(".mp3") ? file.name : `${file.name}.mp3`;
      setProgramacionForm((prev) => ({ ...prev, audioArchivo: fallbackName }));
    }
  };

  const getDefaultPause = () => pausas[0] || null;
  const defaultPause = getDefaultPause();
  const defaultPauseAudioUrl = buildPauseAudioUrl(defaultPause?.audioArchivo);

  const sendDefaultPauseToDevice = async (dispositivo) => {
    const defaultPause = getDefaultPause();
    if (!defaultPause) {
      Swal.fire("Falta pausa", "Primero crea una pausa activa de envío rápido.", "warning");
      return;
    }

    try {
      const canal = String(dispositivo?.metodoComunicacion || dispositivo?.metodo_comunicacion || "MQTT").toUpperCase();
      await axios.post(PausasActivasEnviosURL, {
        empresaId,
        pausaActivaId: Number(defaultPause.id),
        dispositivoId: dispositivo?.id ? Number(dispositivo.id) : null,
        motivo: "ENVIO_MANUAL",
        usuarioSistema: "API",
        canalComunicacion: canal,
      });
      await loadAll();
      Swal.fire("Enviado", `Se envió ${defaultPause.nombre} al dispositivo`, "success");
    } catch (error) {
      console.error("Error registrando envío:", error);
      Swal.fire("Error", "No se pudo registrar el envío", "error");
    }
  };

  return (
    <div>
      <NavBar />
      <div style={shellStyles}>
        <div style={{ maxWidth: 1520, margin: "0 auto", padding: "0 18px" }}>
          <Card style={heroCardStyles} className="mb-4">
            <Card.Body style={{ padding: 28 }}>
              <Row className="g-4 align-items-center">
                <Col xl={8}>
                  <div style={{ color: "#2563eb", fontSize: 12, fontWeight: 800, letterSpacing: 1.4, textTransform: "uppercase" }}>
                    Operación / Seguridad vial
                  </div>
                  <h1 style={{ fontSize: "clamp(2rem, 4vw, 3.3rem)", fontWeight: 900, margin: "10px 0 12px" }}>
                    Pausas activas y somnolencia
                  </h1>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                    <Button variant="info" onClick={openCreatePauseModal}>
                      Crear pausa activa
                    </Button>
                    <Button variant="outline-light" onClick={openQuickPauseModal}>
                      Editar pausa activa de envío rápido
                    </Button>
                  </div>
                </Col>

                <Col xl={4}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                      gap: 12,
                    }}
                  >
                    {metrics.map((metric) => (
                      <StatPill key={metric.label} {...metric} />
                    ))}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 10,
              marginBottom: 18,
            }}
          >
            {[
              { id: "catalogo", label: "Catálogo", description: "Crear y revisar pausas activas" },
              { id: "envios", label: "Envíos", description: "Despacho de órdenes al dispositivo" },
              { id: "somnolencia", label: "Somnolencia", description: "Registro de eventos y acción" },
            ].map((item) => {
              const active = tab === item.id;
              return (
                    <button
                      key={item.id}
                      type="button"
                      onClick={() => setTab(item.id)}
                      style={{
                        minWidth: 220,
                        flex: "1 1 220px",
                        textAlign: "left",
                        border: active ? "1px solid rgba(125, 211, 252, 0.7)" : "1px solid rgba(148, 163, 184, 0.16)",
                        background: active ? "rgba(15, 23, 42, 1)" : "rgba(15, 23, 42, 0.82)",
                        color: "#f8fafc",
                        borderRadius: 20,
                        padding: "14px 18px",
                        boxShadow: active ? "0 16px 32px rgba(0, 0, 0, 0.28)" : "none",
                      }}
                    >
                  <div style={{ fontWeight: 800, fontSize: 16 }}>{item.label}</div>
                  <div style={{ opacity: 0.78, fontSize: 13, marginTop: 4 }}>{item.description}</div>
                </button>
              );
            })}
          </div>

          {loading ? (
            <Card style={sectionCardStyles}>
              <Card.Body style={{ minHeight: 260, display: "grid", placeItems: "center" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, color: "#cbd5e1" }}>
                  <Spinner animation="border" />
                  <span>Cargando información...</span>
                </div>
              </Card.Body>
            </Card>
          ) : (
            <>
              {tab === "catalogo" && (
                <Row className="g-4">
                  <Col xs={12}>
                    <Card style={listCardStyles}>
                      <Card.Body style={{ padding: 24 }}>
                        <SectionHeader
                          title="Pausas activas programadas"
                          subtitle="Cada pausa se crea o edita desde el modal superior y aquí solo queda el registro operativo."
                        />

                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                              gap: 14,
                            }}
                          >
                            {programaciones.map((programacion) => (
                              <div
                                key={programacion.id}
                                style={{
                                  borderRadius: 20,
                                  padding: 18,
                                  background: "rgba(15, 23, 42, 0.72)",
                                  border: "1px solid rgba(148, 163, 184, 0.16)",
                                  minHeight: 230,
                                }}
                              >
                                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                                  <div>
                                    <div style={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1 }}>
                                      Programación {programacion.id}
                                    </div>
                                    <h4 style={{ margin: "8px 0 0", color: "#f8fafc", fontWeight: 800 }}>
                                      {pausas.find((p) => Number(p.id) === Number(programacion.pausaActivaId))?.nombre ||
                                        `Pausa ${programacion.pausaActivaId}`}
                                    </h4>
                                  </div>
                                  <Badge bg={programacion.activo ? "success" : "secondary"} pill style={{ height: "fit-content" }}>
                                    {programacion.activo ? "Activa" : "Inactiva"}
                                  </Badge>
                                </div>

                                <div style={{ display: "grid", gap: 8, marginTop: 14, color: "#cbd5e1", fontSize: 14 }}>
                                  <div>
                                    <b>Alcance:</b> {programacion.alcance}
                                  </div>
                                  <div>
                                    <b>Destino:</b> {describeTargets(programacion, dispositivos)}
                                  </div>
                                  <div>
                                    <b>Hora:</b> {String(programacion.horaEjecucion || "").slice(0, 5)} · <b>Repite:</b> {programacion.repeticion}
                                  </div>
                                  <div>
                                    <b>Días:</b> {formatDiasSemana(programacion.diasSemanaJson)}
                                  </div>
                                  <div>
                                    <b>Vigencia:</b> {programacion.fechaInicio || "-"} a {programacion.fechaFin || "sin fin"}
                                  </div>
                                  <div style={{ fontSize: 12, opacity: 0.8 }}>
                                    Creador: {programacion.usuarioCreador || "-"}
                                  </div>
                                </div>

                                <div style={{ marginTop: 14, display: "flex", gap: 10 }}>
                                  <Button size="sm" variant="outline-info" onClick={() => openProgramacionEditModal(programacion)}>
                                    Editar
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>

                          {programaciones.length === 0 && <EmptyState text="No hay programaciones registradas todavía." />}
                        </Card.Body>
                      </Card>
                  </Col>
                </Row>
              )}

              {tab === "envios" && (
                <Row className="g-4">
                  <Col xl={7}>
                    <Card style={listCardStyles}>
                      <Card.Body style={{ padding: 24 }}>
                        <SectionHeader
                          title="Dispositivos activos"
                          subtitle="El botón envía directo la pausa activa por defecto al dispositivo seleccionado."
                        />

                        {defaultPause ? (
                          <div
                            style={{
                              marginBottom: 16,
                              padding: 16,
                              borderRadius: 18,
                              background: "rgba(15, 23, 42, 0.92)",
                              border: "1px solid rgba(96, 165, 250, 0.22)",
                            }}
                          >
                            <div style={{ color: "#93c5fd", fontSize: 12, fontWeight: 800, letterSpacing: 1.1, textTransform: "uppercase" }}>
                              Audio precargado para envío
                            </div>
                            <div style={{ marginTop: 8, color: "#f8fafc", fontWeight: 800, fontSize: 16 }}>
                              {defaultPause.nombre}
                            </div>
                            <div style={{ marginTop: 6, color: "#cbd5e1", fontSize: 14 }}>
                              Archivo: <b>{defaultPause.audioArchivo || "-"}</b>
                            </div>
                            <div style={{ marginTop: 10 }}>
                              {defaultPauseAudioUrl ? (
                                <audio controls preload="auto" src={defaultPauseAudioUrl} style={{ width: "100%" }} />
                              ) : (
                                <div style={{ color: "#94a3b8", fontSize: 13 }}>La pausa no tiene audio asociado.</div>
                              )}
                            </div>
                          </div>
                        ) : null}

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
                            gap: 14,
                          }}
                        >
                          {dispositivos.map((dispositivo) => {
                            const protocoloLabel =
                              dispositivo?.protocolosModel?.codigo ||
                              dispositivo?.protocolosModel?.nombre ||
                              dispositivo?.protocolosModel?.id ||
                              "-";
                            return (
                              <div
                                key={dispositivo.id}
                                style={{
                                  borderRadius: 20,
                                  padding: 18,
                                  background: "rgba(15, 23, 42, 0.72)",
                                  border: "1px solid rgba(148, 163, 184, 0.16)",
                                  minHeight: 190,
                                }}
                              >
                                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                                  <div>
                                    <div style={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1 }}>
                                      Dispositivo {dispositivo.id}
                                    </div>
                                    <h4 style={{ margin: "8px 0 0", color: "#f8fafc", fontWeight: 800 }}>
                                      {dispositivo.nombre || "Sin nombre"}
                                    </h4>
                                  </div>
                                  <Badge bg={dispositivo.estado ? "success" : "secondary"} pill style={{ height: "fit-content" }}>
                                    {dispositivo.estado ? "Activo" : "Inactivo"}
                                  </Badge>
                                </div>

                                <div style={{ display: "grid", gap: 6, marginTop: 14, color: "#cbd5e1", fontSize: 14 }}>
                                  <div>
                                    <b>Método:</b> {dispositivo.metodoComunicacion || "-"}
                                  </div>
                                  <div>
                                    <b>Protocolo:</b> {protocoloLabel}
                                  </div>
                                  <div>
                                    <b>Ruta:</b> {dispositivo.rutasModel?.nombre || dispositivo.rutasModel?.id || "-"}
                                  </div>
                                </div>

                                <div style={{ marginTop: 14, display: "flex", gap: 10 }}>
                                  <Button size="sm" variant="info" onClick={() => sendDefaultPauseToDevice(dispositivo)}>
                                    Enviar pausa activa
                                  </Button>
                                </div>
                              </div>
                            );
                          })}
                        </div>

                        {dispositivos.length === 0 && <EmptyState text="No hay dispositivos activos para enviar pausas." />}
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col xl={5}>
                    <Card style={listCardStyles}>
                      <Card.Body style={{ padding: 24 }}>
                        <SectionHeader
                          title="Historial de envíos"
                          subtitle="Cada envío debe quedar rastreable. El estado final se actualiza cuando el dispositivo responde por ACK."
                        />

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                            gap: 14,
                          }}
                        >
                          {envios.map((envio) => (
                            <div
                              key={envio.id}
                              style={{
                                borderRadius: 20,
                                padding: 18,
                                background: "rgba(15, 23, 42, 0.72)",
                                border: "1px solid rgba(148, 163, 184, 0.16)",
                                minHeight: 220,
                              }}
                            >
                              <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                                <div>
                                  <div style={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1 }}>
                                    Envío {envio.id}
                                  </div>
                                  <h4 style={{ margin: "8px 0 0", color: "#f8fafc", fontWeight: 800 }}>
                                    {envio.pausaNombre ?? `Pausa ${envio.pausaActivaId}`}
                                  </h4>
                                </div>
                                <Badge bg={stateVariant(envio.estado)} pill style={{ height: "fit-content" }}>
                                  {envio.estado}
                                </Badge>
                              </div>

                              <div style={{ display: "grid", gap: 8, marginTop: 14, color: "#cbd5e1", fontSize: 14 }}>
                                <div>
                                  <b>Dispositivo:</b> {envio.dispositivoId ?? "-"}
                                </div>
                                <div>
                                  <b>Canal:</b> {envio.canalComunicacion ?? "-"} · <b>Motivo:</b> {envio.motivo || "-"}
                                </div>
                                <div>
                                  <b>Fecha:</b> {formatDate(envio.fechaEnvio)}
                                </div>
                                <div style={{ fontSize: 12, opacity: 0.8 }}>
                                  Respuesta: {envio.respuestaDispositivo || "Sin respuesta aún"}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        {envios.length === 0 && <EmptyState text="No hay envíos registrados todavía." />}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}

              {tab === "somnolencia" && (
                <Row className="g-4">
                  <Col xs={12}>
                    <Card style={listCardStyles}>
                      <Card.Body style={{ padding: 24 }}>
                        <SectionHeader
                          title="Eventos de somnolencia"
                        />

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                            gap: 14,
                          }}
                        >
                          {eventos.map((evento) => (
                            <div
                              key={evento.id}
                              style={{
                                borderRadius: 20,
                                padding: 18,
                                background: "rgba(15, 23, 42, 0.72)",
                                border: "1px solid rgba(148, 163, 184, 0.16)",
                                minHeight: 220,
                              }}
                            >
                              <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                                <div>
                                  <div style={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1 }}>
                                    Evento {evento.id}
                                  </div>
                                  <h4 style={{ margin: "8px 0 0", color: "#f8fafc", fontWeight: 800 }}>
                                    Somnolencia {evento.nivel}
                                  </h4>
                                </div>
                                <Badge bg={severityVariant(evento.nivel)} pill style={{ height: "fit-content" }}>
                                  {evento.nivel}
                                </Badge>
                              </div>

                              <div style={{ display: "grid", gap: 8, marginTop: 14, color: "#cbd5e1", fontSize: 14 }}>
                                <div>
                                  <b>Vehículo:</b> {evento.vehiculoId ?? "-"} · <b>Conductor:</b> {evento.conductorId ?? "-"}
                                </div>
                                <div>
                                  <b>Fuente:</b> {evento.fuente} · <b>Acción:</b> {evento.accionEjecutada}
                                </div>
                                <div>
                                  <b>Pausa ligada:</b> {evento.pausaEnvioId ?? "-"}
                                </div>
                                <div>
                                  <b>Fecha:</b> {formatDate(evento.fechaHora)}
                                </div>
                                <div style={{ fontSize: 12, opacity: 0.8 }}>
                                  Evidencia: {evento.evidencia || "Sin evidencia"}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        {eventos.length === 0 && <EmptyState text="Sin eventos de somnolencia." />}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}

              <Modal show={showPauseModal} onHide={() => setShowPauseModal(false)} centered size="xl">
                <Modal.Header closeButton style={{ background: "#111827", color: "#f8fafc", borderBottom: "1px solid #334155" }}>
                  <Modal.Title>
                    {selectedPauseId
                      ? "Editar pausa activa de envío rápido"
                      : selectedProgramacionId
                        ? "Editar pausa programada"
                        : "Crear pausa activa"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#111827", color: "#f8fafc" }}>
                  <Form onSubmit={handleProgramacionSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Nombre</Form.Label>
                      <Form.Control
                        className={inputDark}
                        style={darkFieldStyle}
                        value={programacionForm.nombre}
                        onChange={(e) => setProgramacionForm({ ...programacionForm, nombre: e.target.value })}
                        placeholder="Pausa activa 2026"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Descripción</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        className={inputDark}
                        style={darkFieldStyle}
                        value={programacionForm.descripcion}
                        onChange={(e) => setProgramacionForm({ ...programacionForm, descripcion: e.target.value })}
                        placeholder="Pausa programada para los lunes a las 8:00"
                      />
                    </Form.Group>

                    <Row className="g-3">
                      <Col sm={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Tipo</Form.Label>
                          <Form.Select
                            className={inputDark}
                            style={darkFieldStyle}
                            value={programacionForm.tipo}
                            onChange={(e) => setProgramacionForm({ ...programacionForm, tipo: e.target.value })}
                          >
                            <option value="SOMNOLENCIA">SOMNOLENCIA</option>
                            <option value="OPERATIVA">OPERATIVA</option>
                            <option value="CAMARA">CAMARA</option>
                            <option value="GPS">GPS</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col sm={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Estado</Form.Label>
                          <Form.Select
                            className={inputDark}
                            style={darkFieldStyle}
                            value={programacionForm.estado ? "true" : "false"}
                            onChange={(e) => setProgramacionForm({ ...programacionForm, estado: e.target.value === "true" })}
                          >
                            <option value="true">Activo</option>
                            <option value="false">Inactivo</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="g-3">
                      <Col sm={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Duración estimada (seg)</Form.Label>
                          <Form.Control
                            type="number"
                            className={inputDark}
                            style={darkFieldStyle}
                            value={programacionForm.duracionEstimadaseg}
                            onChange={(e) =>
                              setProgramacionForm({
                                ...programacionForm,
                                duracionEstimadaseg: Number(e.target.value),
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                          <Col sm={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Audio asociado</Form.Label>
                              <Form.Control
                                className={inputDark}
                                style={darkFieldStyle}
                                value={programacionForm.audioArchivo}
                                onChange={(e) => setProgramacionForm({ ...programacionForm, audioArchivo: e.target.value })}
                                placeholder="pausa_programada_2026.mp3"
                              />
                              <Form.Control
                                className={`mt-2 ${inputDark}`}
                                style={darkFieldStyle}
                                type="file"
                                accept=".mp3,audio/mpeg"
                                onChange={(e) => handleAudioUploadChange(e.target.files?.[0] || null)}
                              />
                              <div style={{ marginTop: 8, color: "#cbd5e1", fontSize: 12 }}>
                                {audioFile ? `Archivo seleccionado: ${audioFile.name}` : "Seleccione un MP3 para subirlo a la pausa."}
                              </div>
                            </Form.Group>
                          </Col>
                    </Row>

                    {selectedPauseId ? null : (
                      <>
                        <Row className="g-3">
                          <Col sm={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Alcance</Form.Label>
                              <Form.Select
                                className={inputDark}
                                style={darkFieldStyle}
                                value={programacionForm.alcance}
                                onChange={(e) => handleProgramacionScopeChange(e.target.value)}
                              >
                                <option value="DISPOSITIVO">Un dispositivo</option>
                                <option value="TODOS">Todos</option>
                                <option value="SELECCIONADOS">Seleccionados</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col sm={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Hora de ejecución</Form.Label>
                              <Form.Control
                                type="time"
                                className={inputDark}
                                style={darkFieldStyle}
                                value={programacionForm.horaEjecucion}
                                onChange={(e) =>
                                  setProgramacionForm({ ...programacionForm, horaEjecucion: e.target.value })
                                }
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        {programacionForm.alcance === "DISPOSITIVO" && (
                          <Form.Group className="mb-3">
                            <Form.Label>Dispositivo</Form.Label>
                            <Form.Select
                              className={inputDark}
                              style={darkFieldStyle}
                              value={programacionForm.dispositivoId}
                              onChange={(e) =>
                                setProgramacionForm({ ...programacionForm, dispositivoId: e.target.value })
                              }
                            >
                              <option value="">Seleccione...</option>
                              {dispositivos.map((dispositivo) => (
                                <option key={dispositivo.id} value={String(dispositivo.id)}>
                                  {dispositivo.id} - {dispositivo.nombre}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        )}

                        {programacionForm.alcance === "SELECCIONADOS" && (
                          <Form.Group className="mb-3">
                            <Form.Label>Dispositivos seleccionados</Form.Label>
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                                gap: 10,
                                maxHeight: 220,
                                overflow: "auto",
                                padding: 12,
                                borderRadius: 16,
                                border: "1px solid rgba(148, 163, 184, 0.16)",
                                background: "rgba(15, 23, 42, 0.72)",
                              }}
                            >
                              {dispositivos.map((dispositivo) => {
                                const checked = selectedProgramacionDevices.includes(Number(dispositivo.id));
                                return (
                                  <label
                                    key={dispositivo.id}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 10,
                                      padding: "8px 10px",
                                      borderRadius: 12,
                                      background: checked ? "rgba(37, 99, 235, 0.14)" : "rgba(15, 23, 42, 0.72)",
                                      border: "1px solid rgba(148, 163, 184, 0.14)",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Form.Check
                                      type="checkbox"
                                      checked={checked}
                                      onChange={() => toggleSelectedProgramacionDevice(Number(dispositivo.id))}
                                    />
                                    <span style={{ color: "#f8fafc", fontSize: 14 }}>
                                      {dispositivo.id} - {dispositivo.nombre}
                                    </span>
                                  </label>
                                );
                              })}
                            </div>
                          </Form.Group>
                        )}

                        <Row className="g-3">
                          <Col sm={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Repetición</Form.Label>
                              <Form.Select
                                className={inputDark}
                                style={darkFieldStyle}
                                value={programacionForm.repeticion}
                                onChange={(e) => handleProgramacionRepeatChange(e.target.value)}
                              >
                                <option value="NINGUNA">Sin repetición</option>
                                <option value="DIARIA">Diaria</option>
                                <option value="SEMANAL">Semanal</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col sm={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Activo</Form.Label>
                              <Form.Select
                                className={inputDark}
                                style={darkFieldStyle}
                                value={programacionForm.activo ? "true" : "false"}
                                onChange={(e) =>
                                  setProgramacionForm({ ...programacionForm, activo: e.target.value === "true" })
                                }
                              >
                                <option value="true">Sí</option>
                                <option value="false">No</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </Row>

                        {programacionForm.repeticion === "SEMANAL" && (
                          <Form.Group className="mb-3">
                            <Form.Label>Días de repetición</Form.Label>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                              {dayOptions.map((day) => {
                                const checked = selectedDias.includes(day.value);
                                return (
                                  <button
                                    key={day.value}
                                    type="button"
                                    onClick={() => toggleSelectedDia(day.value)}
                                    style={{
                                      minWidth: 56,
                                      padding: "10px 14px",
                                      borderRadius: 12,
                                      border: checked
                                        ? "1px solid rgba(37, 99, 235, 0.72)"
                                        : "1px solid rgba(148, 163, 184, 0.16)",
                                      background: checked ? "rgba(37, 99, 235, 0.14)" : "rgba(15, 23, 42, 0.72)",
                                      color: "#f8fafc",
                                      fontWeight: 800,
                                    }}
                                  >
                                    {day.label}
                                  </button>
                                );
                              })}
                            </div>
                          </Form.Group>
                        )}

                        <Row className="g-3">
                          <Col sm={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Fecha inicio</Form.Label>
                              <Form.Control
                                type="date"
                                className={inputDark}
                                style={darkFieldStyle}
                                value={programacionForm.fechaInicio}
                                onChange={(e) =>
                                  setProgramacionForm({ ...programacionForm, fechaInicio: e.target.value })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col sm={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Fecha fin</Form.Label>
                              <Form.Control
                                type="date"
                                className={inputDark}
                                style={darkFieldStyle}
                                value={programacionForm.fechaFin}
                                onChange={(e) =>
                                  setProgramacionForm({ ...programacionForm, fechaFin: e.target.value })
                                }
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}

                    <Button type="submit" className="w-100 py-2 fw-bold">
                      {selectedPauseId
                        ? "Actualizar pausa activa de envío rápido"
                        : selectedProgramacionId
                          ? "Actualizar pausa programada"
                          : "Guardar pausa programada"}
                    </Button>
                  </Form>
                </Modal.Body>
              </Modal>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
